import * as React from 'react'
import { SVGProps } from 'react'

const SvgRefreshIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <g clipPath='url(#refreshIcon_svg__a)' fill='#fff'>
      <path d='M11.999 2a10.032 10.032 0 0 1 7.122 3h-3.122a1 1 0 1 0 0 2h4.143a1.858 1.858 0 0 0 1.857-1.857V1a1 1 0 0 0-2 0v2.078C15.082-1.35 7.507-.954 3.079 3.963A11.98 11.98 0 0 0 .049 10.9a1.007 1.007 0 0 0 1 1.1.982.982 0 0 0 .99-.878A10.014 10.014 0 0 1 11.998 2Z' />
      <path
        opacity={0.4}
        d='M22.95 12a.982.982 0 0 0-.989.878A9.986 9.986 0 0 1 4.878 19H8a1 1 0 1 0 0-2H3.857C2.832 17 2 17.83 2 18.855V23a1 1 0 0 0 2 0v-2.078c4.917 4.428 12.492 4.032 16.92-.885a11.98 11.98 0 0 0 3.03-6.937 1.007 1.007 0 0 0-1-1.1Z'
      />
    </g>
    <defs>
      <clipPath id='refreshIcon_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
)

export default SvgRefreshIcon
